import Component from '../abstracts/Component';
import ScrollMagic from 'scrollmagic';
import vex from 'vex-js';

export default class PdpMainComponent extends Component {
  get SELECTORS() {
    return {
      header: '[data-js-component="HeaderComponent"]',
      wrapper: '[data-wrapper]',
      infoContainer: '[data-product-info]',
      skuInfo: '[data-info-container]',
      completeLook: '[data-js-component="CompleteLookComponent"]',
      images: '[data-images]',
      image: '[data-image]',
      sizeGuideTrigger: "[data-js-size-guide]",
    };
  }

  constructor(compEl) {
    super(compEl);
    this.infoContainer = this.$component.querySelector(this.SELECTORS.infoContainer);
    this.wrapper = this.$component.querySelector(this.SELECTORS.wrapper);
    this.skuInfo = this.$component.querySelector(this.SELECTORS.skuInfo);

    this.completeLook = this.$component.querySelector(this.SELECTORS.completeLook);
    this.completeLookOffsetHeight = this.completeLook ? this.completeLook.offsetHeight : 0;

    this.imagesColumn = this.$component.querySelector(this.SELECTORS.images);
    this.lastImages = this.$component.querySelectorAll(this.SELECTORS.image);
    this.lastImage = this.lastImages[this.lastImages.length - 1];
    this.lastImageOffsetHeight = this.completeLook ? this.lastImage.offsetHeight : 0;

    this.sizeGuideTrigger = this.$component.querySelector(this.SELECTORS.sizeGuideTrigger);

    this.offset = 50;
    this.scrollOffset = 0;

    this.headerHeight = document.querySelector( this.SELECTORS.header).offsetHeight;
  }

  // handle size guide open //
  handleSizeGuide() {
    const self = this;
    if (this.sizeGuideTrigger) {
      this.sizeGuideTrigger.addEventListener("click", (event) => {
        event.preventDefault();
        this.sizeGuideTrigger.setAttribute('disabled', '');
        fetch(this.sizeGuideTrigger.href)
          .then(response => response.text())
          .then(text => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(text, "text/html");
            const sizeGuide = doc.querySelector('[data-ajax-chunk]');
            vex.open({
              unsafeContent: sizeGuide,
              closeClassName: 'icon-close',
              className: 'size-guide',
              showCloseButton: true,
              afterOpen: function () {
                this.closeEl.classList.remove('vex-close');
                self.importComponents("CollapseComponent")
                  .then(({default: module}) => {
                    const component = new module(sizeGuide);
                    component.render();
                  })
                  .catch(error => {
                    console.error("Failed to load the component", error.stack);
                  });
              },
              afterClose: function () {
                self.sizeGuideTrigger.removeAttribute('disabled');
              }
            });
          })
          .catch(error => console.error(error));
      });
    }
  }

  importComponents(componentName) {
    return import(`../components/${componentName}`);
  }

  bindEvents() {
    this.handleSizeGuide();
  }

  render() {
    super.render();
    if (window.matchMedia('(min-width: 768px)').matches) {
      this.controller = new ScrollMagic.Controller();
      this.initSceneParams();
      this.setScene();
      this.startScene();
    }
    this.bindEvents();
  }

  initSceneParams() {
    this.skuInfoOffsetHeight = this.skuInfo.offsetHeight;
    this.translateOffset =
      this.skuInfoOffsetHeight -
      window.innerHeight +
      this.offset +
      this.headerHeight;
    this.translateDuration =
      this.imagesColumn.offsetHeight +
      this.translateOffset -
      this.skuInfoOffsetHeight -
      Math.max(this.lastImageOffsetHeight, this.completeLookOffsetHeight);

    const sceneDuration = this.wrapper.offsetHeight -
      Math.max(this.lastImageOffsetHeight, this.completeLookOffsetHeight) -
      this.skuInfoOffsetHeight -
      this.offset / 2;

    // Make sure duration is never less than 0.
    // This might happen for example when there's only one image (see MA-2561).
    this.sceneDuration = sceneDuration <= 0 ? 1000 : sceneDuration;

    this.sceneOffset = Math.max(
      this.skuInfoOffsetHeight -
      window.innerHeight +
      this.offset,
      0
    );
  }

  setScene() {
    window.addEventListener('resize', () => {
      this.updateScene();
    });
    this.scene = new ScrollMagic.Scene({
      triggerElement: this.SELECTORS.wrapper,
      offset: this.sceneOffset,
      triggerHook: '0',
      duration: this.sceneDuration,
    });
    if (this.translateOffset > 0) {
      if (this.scrollListener) {
        removeEventListener('scroll', this.scrollListener);
      }
      this.scrollListener = window.addEventListener('scroll', () => {
        if (
          this.translateDuration > 0 &&
          window.pageYOffset < this.scrollOffset &&
          window.pageYOffset > this.translateOffset &&
          window.pageYOffset < this.translateDuration
        ) {
          this.skuInfo.style.transform =
            'translateY(' + this.translateOffset + 'px)';
        } else {
          this.skuInfo.style.transform = 'translateY(0px)';
        }
        this.scrollOffset = window.pageYOffset;
      });
    }
  }

  startScene() {
    this.scene.setPin(this.SELECTORS.skuInfo).addTo(this.controller);
  }

  updateScene() {
    this.initSceneParams();
    this.scene.duration(this.sceneDuration);
    this.scene.offset(this.sceneOffset);
  }
}
